// Energy type to icon mapping
export const ENERGY_ICONS = {
  Colorless: '/energy/colorless.png',
  Darkness: '/energy/darkness.png',
  Dragon: '/energy/dragon.png',
  Fighting: '/energy/fighting.png',
  Fire: '/energy/fire.png',
  Grass: '/energy/grass.png',
  Lightning: '/energy/lightning.png',
  Metal: '/energy/metal.png',
  Psychic: '/energy/psychic.png',
  Water: '/energy/water.png'
} as const;

export type EnergyType = keyof typeof ENERGY_ICONS;